import styled from 'styled-components';

const ErrorMessage = styled.p`
  position: absolute;
  padding-right: 10px;
  top: 65px;
  left: 15px;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  text-align: right;
  color: ${(props) => props.theme.colors.red}
`;

const ItemWrapper = styled.div`
  padding: 16px;
  font-size: 13px;
  cursor: pointer;
  
  &:first-of-type {
    border-radius: 12px 12px 0 0;
  }
  
  &:last-of-type {
    border-radius: 0 0 12px 12px;
  }
  
  input[type="checkbox"],
  input[type="radio"]{
    display:none;
  }
  
  .checkbox {
    display:inline-block;
    width: 16px;
    height: 16px;
    margin: 0 8px -4px 0; 
    position: relative;
    
    &:before {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      z-index: 1;
      width: 16px;
      height: 16px;
      background: transparent;
      border: 1px solid ${(props) => props.theme.colors.inactive};
    }
    
    &:after {
      transition: all .3s ease-in-out;
      content: "";
      position: absolute;
      width: 16px;
      height: 16px;
      background: transparent;
      z-index: 0;
      border: none;
    }
  }

  input[type="checkbox"] + label .checkbox {
    &:before,
    &:after {
      border-radius: 4px;
    }
  }

  input[type="radio"] + label .checkbox {
    &:before,
    &:after {
      border-radius: 50%;
    }
  }

  input[type="checkbox"]:checked + label .checkbox,
  input[type="radio"]:checked + label .checkbox{
    &:after {
      width: 16px;
      height: 16px;
      background: ${(props) => props.theme.colors.main_cta};
      transition: all .2s ease-in;
    }
  }

  input[type="checkbox"]:checked + label .checkbox,
  input[type="radio"]:checked + label .checkbox{
    &:before {
      left: 5px;
      top: 2px; 
      width: 6px;
      height: 11px;
      border: solid ${(props) => props.theme.colors.inactive};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }

  label.disabled {
    cursor: not-allowed;
    opacity: 50%;
  }
`;

export default { ErrorMessage, ItemWrapper };
